<template>
	<div style="width: 100%;">
		<keep-alive>
			<router-view/>
		</keep-alive>
	</div>
</template>

<script>
export default {
	name: "BasicLayout"
}
</script>


<style scoped lang="less">
</style>
